import http from '@/utils/http'
const endpoint = 'aggregate'

export default {
  async chooseMonth (choose_month,pms_code,no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const data = {
      params: {
        choose_month,
        pms_code
      }
    }
    const res = await http.get(`${endpoint}/choose-month`,data, config)
    return res.data
  },
  async pastThreeMonths (pms_code,no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const data = {
      params: {
        pms_code
      }
    }
    const res = await http.get(`${endpoint}/past-three-months`,data, config)
    return res.data
  },
  async download(params) {
    const response = await http.get(`${endpoint}/download`, {
            params,
            responseType: 'arraybuffer',
        });
    return response;
  }
  
}
